<div
  class="dropdown-menu custom-dropdown notifications"
  [ngClass]="
    notifications && notifications.length
      ? 'notification-width'
      : 'notification-auto'
  "
  [class.show]="showNotification"
>
  <div class="topnav-dropdown-header">
    <span class="notification-title">Notification</span>
    <span class="clear-noti" *ngIf="notifications && notifications.length">
      {{ today | date: "dd MMM yyyy" : "Africa/Harare" }}
    </span>
  </div>
  <div class="noti-content">
    <ul class="notification-list" style="display: block !important">
      <li
        class="notification-message"
        *ngFor="let noti of notifications"
        [ngClass]="{
          'active-message':
            noti?.id === selectedNotification?.id || noti?.is_read === 1,
        }"
      >
        <div class="media-body">
          <div class="row">
            <div class="col-lg-9 notifcation-header">
              <img
                [src]="getNotificationIcon(noti.type_id)"
                alt="icon"
                width="20"
                height="20"
              />
              <h6 style="color: gray">
                {{ noti.title }}
              </h6>
            </div>
            <div class="col-lg-3">
              <span class="notification-time">
                {{ noti.createdAt | date: "hh:mm a" : "Africa/Harare" }}
              </span>
            </div>
          </div>
          <div class="content-block">
            <p
              class="noti-details"
              style="margin-bottom: 1px !important"
              [innerHTML]="noti.message"
            ></p>
            <img
              class="info-icon"
              src="/assets/reason_info.webp"
              alt=""
              (click)="openNotificationPopup(noti, $event)"
            />
            <!-- Un Read -->
            <i
              *ngIf="noti.is_read === 1"
              class="fa fa-envelope unread-icon"
              title="Unread"
            ></i>

            <!-- Read -->
            <i
              *ngIf="noti.is_read === 0"
              class="fa fa-envelope-open read-icon"
              title="Read"
            ></i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="side-popup" *ngIf="isNotificationOpen && showNotification">
  <div class="popup-header">
    <span class="title">Notification Details</span>
    <span class="close-btn" (click)="closeNotificationPopup()">×</span>
  </div>

  <div class="popup-body">
    <div class="info-item">
      <span class="label">Booking ID</span>
      <span class="value">{{
        notificationDetails.bookingType == "AMBULANCE"
          ? notificationDetails.bookingInfo?.ambulance_booking_id
          : notificationDetails.bookingInfo?.tc_booking_id
      }}</span>
    </div>

    <div class="info-item">
      <span class="label">Full Name</span>
      <span class="value">{{
        `${notificationDetails?.userInfo?.first_name} ${notificationDetails?.userInfo?.last_name ?? ""}`
      }}</span>
    </div>

    <div class="info-item">
      <span class="label">Contact Number</span>
      <span class="value">{{ notificationDetails?.userInfo?.phone }}</span>
    </div>

    <div class="info-item">
      <span class="label">Notification Time</span>
      <span class="value">{{
        notificationDetails?.notification?.createdAt
          | date: "hh:mm a" : "Africa/Harare"
      }}</span>
    </div>

    <div class="info-item">
      <span class="label">Channel</span>
      <span class="value">{{
        notificationDetails?.channelInfo?.channel_name | titlecase
      }}</span>
    </div>

    <div class="info-item">
      <span class="label">Status</span>
      <span class="value">{{
        (notificationDetails.bookingType == "AMBULANCE"
          ? notificationDetails.bookingInfo?.ride_status
          : notificationDetails.bookingInfo?.tc_booking_status
        ) | titlecase
      }}</span>
    </div>
  </div>
</div>
